module.exports = __webpack_public_path__ + "img/icon_sns_05.7312da77.svg";